import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { EParkingType } from '../../../../json_query';
import { changeParking } from '../../../state/advanced/parking';
import { InlineParam, Row } from '../markup';

interface IParkingProps {
  parkings: EParkingType[];
  onParkingChange(parkingType: EParkingType, value: boolean): void;
}

const isParkingExists = (existingParkingTypes: EParkingType[], parking: EParkingType): boolean => {
  return existingParkingTypes.indexOf(parking) > -1;
};

const Parking: React.StatelessComponent<IParkingProps> = props => (
  <Row title="Парковка">
    {[
      { name: 'Наземная', type: EParkingType.Ground },
      { name: 'Многоуровневая', type: EParkingType.Multilevel },
      { name: 'Подземная', type: EParkingType.Underground },
      { name: 'На крыше', type: EParkingType.Rooftop },
    ].map((parkingProps, i) => (
      <InlineParam key={i.toString()}>
        <ButtonCheckbox
          onValueChange={value => props.onParkingChange(parkingProps.type, value)}
          value={isParkingExists(props.parkings, parkingProps.type)}
        >
          {parkingProps.name}
        </ButtonCheckbox>
      </InlineParam>
    ))}
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    parkings: (state.filters.jsonQuery.parking_type && state.filters.jsonQuery.parking_type.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onParkingChange: (parkingType: EParkingType, value: boolean) => {
      dispatch(changeParking(parkingType, value));
    },
  }),
)(Parking);
